<script setup lang="ts">
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import type { ProductGroup } from '@/services/pcsServiceTypes'
import BaseButton from '@/components/ui/button/BaseButton.vue'
import ProductCard from './_ProductCard.vue'
import Spinner from './_Spinner.vue'
import { cn } from '@/lib/utils'

const { t } = useI18n()

const props = defineProps({
	products: Array as () => ProductGroup[],
	isShowMore: Boolean,
	isFilterOpen: Boolean,
	showRawTitle: Boolean,
	isLoading: Boolean,
})

const emit = defineEmits(['loadMoreProducts'])

const buttonText = computed(() => {
	return props.isLoading ? t('pcs_button_wait') : t('pcs_button_show_more')
})

const showSpinner = computed(() => props.isLoading)
const buttonDisabled = computed(() => props.isLoading)
const showButton = computed(() => props.isLoading || props.isShowMore)

const loadMoreProducts = () => {
	if (!props.isLoading) {
		emit('loadMoreProducts')
	}
}
</script>

<template>
	<div
		:class="
			cn(
				'grid grid-cols-2 gap-x-16px gap-y-20px mdp:grid-cols-3 mdp:gap-y-24px mdl:grid-cols-4 mdl:gap-x-20px lg:grid-cols-5 lg:gap-x-16px',
				{
					'lg:grid-cols-4 lg:!gap-x-[15.33px]': isFilterOpen,
				},
			)
		"
	>
		<ProductCard
			v-for="(product, index) in products"
			:key="product.title"
			:product="product"
			:showRawTitle="showRawTitle"
		/>
	</div>
	<div
		v-if="showButton"
		class="item-center mt-32px flex justify-center mdp:mt-60px"
	>
		<BaseButton
			@click="loadMoreProducts"
			variant="secondary"
			:disabled="buttonDisabled"
		>
			<template v-if="showSpinner" #leadingIcon>
				<Spinner></Spinner>
			</template>
			{{ buttonText }}
		</BaseButton>
	</div>
</template>
